module.exports = __webpack_public_path__ + "img/29.3d477208.svg";